import { AxiosResponse } from 'axios';
import {
  AcceptIncidentOptional,
  RejectionCode,
  IGetRepairPartnerList,
  IGetRepairPartnerListSearch,
  IPostponeIncident,
  IRepairPartnerFilterResponse,
  IRepairPartnerItemsResponse,
  IUpdateStep,
  StepType,
  UploadSettleUpDateType
} from './requests-service.props';
import { ResponseModel, TableRequest } from 'common/interfaces';
import { StatusDescriptionId } from 'pages/my-requests/components/table/expand/expand.props';
import { DateFieldName } from 'pages/my-requests/components/table/expand/steps-controller/completion-confirmed/form/form.props';
import axiosInstance from '../../shared/api/axios-instance';

class RequestService {
  getRepairPartnerList = async ({
    pagination,
    search
  }: Omit<TableRequest<IGetRepairPartnerListSearch>, 'sort'>): Promise<
    AxiosResponse<ResponseModel<IGetRepairPartnerList>>
  > => {
    return axiosInstance({
      method: 'POST',
      url: 'incidents/repair-partner-list',
      data: {
        Pagination: {
          Start: pagination.start,
          Number: pagination.number
        },
        Search: search
      }
    });
  };

  getRepairPartnerById = async (
    incidentId: string
  ): Promise<AxiosResponse<ResponseModel<Partial<IRepairPartnerItemsResponse>>>> => {
    return axiosInstance({
      method: 'GET',
      url: `incidents/get-incident/${incidentId}`
    });
  };

  getRepairPartnerFilters = async (): Promise<AxiosResponse<ResponseModel<IRepairPartnerFilterResponse>>> => {
    return axiosInstance({
      method: 'GET',
      url: 'incidents/repair-partner-list-filters'
    });
  };

  postponeIncident = async (data: IPostponeIncident) => {
    return axiosInstance({
      method: 'POST',
      url: 'incidents/postpone-incident',
      data
    });
  };

  updateStep = async (data: IUpdateStep) => {
    return axiosInstance({
      method: 'POST',
      url: 'incidents/updatestep-incident',
      data: {
        StepModel: data
      }
    });
  };

  uploadSettleUpDate = async (incidentId: string, stepType: StepType, data: UploadSettleUpDateType) => {
    return axiosInstance({
      method: 'POST',
      url: 'incidents/updatestepmodel',
      data: {
        Incident: {
          id: incidentId,
          Attributes: {
            uds_rap_reparartur_ende: {
              attributeValue: data[DateFieldName.EndOfRepair],
              attributeTypeCode: 2
            },
            uds_rap_reparaturbeginn: {
              attributeValue: data[DateFieldName.StartOfRepair],
              attributeTypeCode: 2
            },
            new__rap_uebergabe_nutzer: {
              attributeValue: data[DateFieldName.HandoverToUser],
              attributeTypeCode: 2
            },
            uds_rap_abholtag: {
              attributeValue: data[DateFieldName.CollectionDay],
              attributeTypeCode: 2
            }
          }
        },
        StepType: stepType
      }
    });
  };

  acceptIncident = async (
    IncidentId: string,
    AuftragStatusDescriptionId: StatusDescriptionId,
    optional: Partial<AcceptIncidentOptional> = {}
  ) => {
    return axiosInstance({
      method: 'POST',
      url: 'incidents/accept-incident',
      data: {
        IncidentId,
        AuftragStatusDescriptionId,
        ...optional
      }
    });
  };

  switchProcessIncident = async (IncidentId: string, AuftragStatusDescriptionId: string) => {
    return axiosInstance({
      method: 'POST',
      url: 'incidents/switch-incident-process',
      data: {
        IncidentId,
        AuftragStatusDescriptionId
      }
    });
  };

  declineIncident = async (IncidentId: string, DeclinedCode: RejectionCode, StepType: StepType) => {
    return axiosInstance({
      method: 'POST',
      url: 'incidents/decline-incident',
      data: {
        StepModel: {
          IncidentId,
          DeclinedCode: +DeclinedCode,
          StepType
        }
      }
    });
  };

  sendEmailOnLoadFile = async (incidentId: string, stepType: StepType, stepSection: string, files: string[]) => {
    return axiosInstance({
      method: 'POST',
      url: 'maineAnfragen/sendEmailOnLoadFile',
      data: {
        incidentId,
        stepType,
        stepSection,
        files
      }
    });
  };
}

export const requestService = new RequestService();
